module.exports = __webpack_public_path__ + "img/intro_uk.5a695389.svg";